import { memo } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { sendNotification } from "features/transactions/api";
import { NotificationSeverity } from "features/general/types";
import useActions from "features/general/useActions";
import useTransactionAction from "./useTransactionAction";

const SendNotification = () => {
    const {
        isLoading,
        transaction,
        request
    } = useTransactionAction();

    const { showNotication } = useActions();

    const onClick = () => request(() => sendNotification(transaction), {
        onSuccess: ({ message }) => showNotication({
            message,
            severity: NotificationSeverity.Info
        })
    });

    return (
        <LoadingButton
            data-test-id="transactions.transactionActions.sendNotification"
            startIcon={(
                <ArrowCircleUpIcon />
            )}
            onClick={onClick}
            loading={isLoading}
            variant='outlined'
            size='small'
        >
            Send notification
        </LoadingButton>
    );
};

export default memo(SendNotification);
